module.exports = __webpack_public_path__ + "static/media/NFT-STOCK-IMAGE.a1c35023.png";